import { render, staticRenderFns } from "./StatusInfo.vue?vue&type=template&id=3e182825&scoped=true"
import script from "./StatusInfo.vue?vue&type=script&lang=js"
export * from "./StatusInfo.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/group_dashboard/status_info.css?vue&type=style&index=0&id=3e182825&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e182825",
  null
  
)

export default component.exports